// AWS Amplify Gen2 Configuration - DEV ENVIRONMENT
// This configuration is for the dev.mockmcp.com environment
// DO NOT use this for production

export const amplifyConfig = {
  Auth: {
    Cognito: {
      // Amazon Cognito User Pool ID - DEV
      userPoolId: 'eu-central-1_bzbgjHSLB',
      
      // Amazon Cognito User Pool App Client ID - DEV
      userPoolClientId: '2safdunmacttt50ojn1090qjev',
      
      // Amazon Cognito Region
      region: 'eu-central-1',
      
      // Custom Cognito Auth Domain - DEV
      loginWith: {
        oauth: {
          domain: 'mockmcp-dev-207567790021',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: ['https://dev.mockmcp.com/login/callback', 'http://localhost:3000/login/callback'],
          redirectSignOut: ['https://dev.mockmcp.com/logout', 'http://localhost:3000/logout'],
          responseType: 'code'
        },
        email: true,
        username: false,
        phone: false
      },
      
      // Optional: Configure user attributes
      userAttributes: {
        email: {
          required: true
        },
        name: {
          required: true
        }
      }
    }
  }
};

// Export individual config parts for potential future use
export const cognitoConfig = amplifyConfig.Auth.Cognito; 

// API Configuration - DEV
export const apiConfig = {
  // API Gateway endpoint for MCP server - DEV
  mcpApiEndpoint: 'https://api.dev.mockmcp.com',
  
  // Custom domain API endpoint - DEV
  customDomainEndpoint: 'https://dev.mockmcp.com',
  
  // DynamoDB table name for sessions - DEV
  // UPDATE THIS after deploying dev stack
  sessionsTableName: 'sam-app-dev-mcp-sessions'
};

